import { render, staticRenderFns } from "./QuestionsUpdate.vue?vue&type=template&id=35481208&scoped=true"
import script from "./QuestionsUpdate.vue?vue&type=script&lang=js"
export * from "./QuestionsUpdate.vue?vue&type=script&lang=js"
import style0 from "./QuestionsUpdate.vue?vue&type=style&index=0&id=35481208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35481208",
  null
  
)

export default component.exports